<template>
  <div class="segmented-control">
    <button
      v-for="option in options"
      :key="option.value"
      type="button"
      :class="['segment', { active: modelValue === option.value }]"
      @click="$emit('update:modelValue', option.value)"
    >
      {{ option.label }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: [String, Number],
    options: Array
  },
  emits: ['update:modelValue']
}
</script>

<style scoped>
.segmented-control {
  display: flex;
  background-color: #ffffff;
  border-radius: 4px;
  overflow: hidden;
  padding: 1px;
  gap: 1px;
  border: 1px solid #dddddd;
}
.segment {
  padding: 0.25rem 0.65rem;
  font-size: 0.75rem;
  line-height: 19px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: #888888;
  cursor: pointer;
  transition: background-color 0.1s, color 0.1s, box-shadow 0.1s;
  white-space: nowrap;
  width: 100%;
}
.segment:hover:not(.active) {
  color: #555555;
}
.segment.active {
  background: #222222;
  color: #ffffff;
}
</style>
